/**
 * 查询群组所有联系人
 **/

import React from 'react';
import { Button, Dropdown, Form, Icon, Tooltip, message, Popconfirm, Select, Radio, Input, Row, Col } from 'antd';
import { Link } from 'react-router';
import { fetchCusWjws } from "../../redux/actions/customization";
import CKDataTablePage2 from '../../components/CKDataTablePage2';
import { deleteCusWjw} from '../../services/customization'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { antdTableColumnsMerge } from "../../utils/index";
import Holder from "../../components/Holder";
import CreateOrEditCscModal from "./CreateOrEditCscModal";


const Option = Select.Option;
const Search = Input.Search;



class CreditSystemConfigs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchParams: Object.assign({}, {
                eventId: '',
            }, this.props.cusWjws.searchParams),
            selectedRowKeys: [],
            selectedRecords: [],
            columns: antdTableColumnsMerge([
                {
                    title: '活动名', width: 200, dataIndex: 'name', render: (text, record, index) => (
                        <Tooltip title={record.event.name}>
                            {record.event.name}
                        </Tooltip>
                    )
                },
                {
                    title: '可得总积分',
                    dataIndex: 'totalStudyTime',
                    width: 140,
                },


                { title: '得分规则', dataIndex: 'type', render:(text,record,index)=>(
                    <span>
                        {this.props.cmEnums.data.WjwRuleTypeEnum[record.type.toString()].enumDesc}
                    </span>
                )},

                {
                    title: '操作',
                    key: 'operation',
                    fixed: 'right',
                    width: 100,
                    render: (text, record, index) => (
                        <span>
                            <a onClick={()=>this.onShowCscModal(record.eventId)}>编辑</a>
                            <span className="ant-divider" />
                            <Popconfirm title={<span>您确定要删除 <span className="mdc-text-red">{record.event.name}</span>活动规则吗?</span>}
                                placement="leftBottom"
                                onConfirm={(e) => {
                                    deleteCusWjw({ id: record.id }).then(res => {
                                        if (res.code == 200) {
                                            message.success('删除成功!');
                                            this.fetchFilterTableData();
                                        } else {
                                            message.error(res.msg,6);
                                        }
                                    }).catch(err => {
                                        message.warn("访问异常");
                                    })
                                }}
                                okText="删除"
                                cancelText="放弃">
                                <a href="#">删除</a>
                            </Popconfirm>
                        </span>
                    ),
                },

            ], (this.props.cusWjws.extra && this.props.cusWjws.extra.columns) ? this.props.cusWjws.extra.columns : [])

        }
    }
    componentDidMount() {
    }
    componentWillReceiveProps(nextProps) {

    }

    handleTableRowsSelectChange = (selectedRowKeys, selectedRecords) => {
        this.setState({ selectedRowKeys, selectedRecords });
    }


    fetchData = (params, pagination = this.props.pagination, sort = this.props.sort) => {
        this.props.fetchCusWjws(Object.assign({}, params), pagination, sort, { columns: this.state.columns });
    }

    fetchFilterTableData() {
        this.refs.GroupsCkDataTablePage.fetchTableData();

    }

    searchParamsChange(propName, val, invokingFetchFilterTableData = true) {
        const searchParams = { ...this.state.searchParams };
        searchParams[propName] = val;
        this.setState({
            searchParams: searchParams,
        }, () => {
            if (invokingFetchFilterTableData) {
                this.fetchFilterTableData();
            }
        });
    }

    handleTableColumnsChange = (columns) => {
        this.setState({
            columns: columns
        })
    }
    onShowCscModal = (eventId = null) => {
        this.setState({
            eventId
        },()=>this.setState({
            cscVisible: true
        }))
    }
    onHideCscModal = () => {
        this.setState({
            cscVisible: false
        })
    }


    render() {

        const ckDataTableToolbarLeft =
            <div>
                {/* <Radio.Group size="large"
                    value={this.state.searchParams.status}
                    onChange={(e) => {
                        this.searchParamsChange("status", e.target.value);
                    }}>
                    {
                        Object.values(this.props.cmEnums.data.CmEventApplyStatus).map((item, index) => {
                            return <Radio.Button value={item.enumName.toString()} key={`event-apply-${index}`}>{item.enumDesc}</Radio.Button >
                        })
                    }
                </Radio.Group> */}
                <Button type="primary" onClick={()=>this.onShowCscModal()}>
                    新增规则
                 </Button>
            </div>
        const ckDataTablerRowSelectionActions =
            <div>
  
            </div>



        return (
            <CKDataTablePage2
                ref='GroupsCkDataTablePage'
                comp={this}
                className={'subevtapplystyle'}
                // tableScroll={{x: 1400, y: 'calc(100vh - 292px)'}}
                tableRowSelectionActions={ckDataTablerRowSelectionActions}
                toolbarLeft={ckDataTableToolbarLeft}
                tableRowKey={record => record.id}
                tableColumns={this.state.columns}
                tableSelectedRowKeys={this.state.selectedRowKeys}
                tableSelectedRowKeysChange={this.handleTableRowsSelectChange}
                tableDataSource={this.props.cusWjws}
                tableDataSourceFetch={this.fetchData}
                tableDataSourceFetchSearchParams={this.state.searchParams}
                tableColumnsChange={this.handleTableColumnsChange}
                reloadOnMount={this.props.lastLocation == null || this.props.lastLocation.action != "POP"}
                tableRowSelectDisabled={true}
                tableColumnsControlDisable={true}>
                {
                    this.state.cscVisible &&
                    <CreateOrEditCscModal
                        eventId={this.state.eventId}
                        hide={this.onHideCscModal}
                        refTable={()=>this.fetchFilterTableData()}
                    />
                }


            </CKDataTablePage2>
        )
    }
}


const mapStateToPorps = state => {
    const cusWjws = state.cusWjws;
    const cmEnums = state.cmEnums;

    return { cusWjws, cmEnums };
};
const mapDispatchToProps = dispatch => ({
    fetchCusWjws: bindActionCreators(fetchCusWjws, dispatch),
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(CreditSystemConfigs));


// WEBPACK FOOTER //
// ./src/containers/usersfrom/CreditSystemConfigs.jsx